import { usePost } from '@hox/frontend-utils/hooks/useFetch';
import { getSearchParams, buildMagicLinkQueryString } from '../lib';
import { MAGIC_LINK_PATH } from '../constants';

export const useMagicLinkData = (
  email: string,
  params: ReturnType<typeof getSearchParams>
) => {
  return usePost<void>(
    `${MAGIC_LINK_PATH}?${buildMagicLinkQueryString({
      email,
      ...params,
    })}`,
    { skip: true }
  );
};
